import axios from 'axios'
const endpoint = process.env.VUE_APP_BASE_API + '/api/master/countries'

const _transformCountryName = (countries) => {
  if (countries && countries.length > 0) {
    countries.forEach(country => {
      if (country.name) {
        const _name = country.name.toLowerCase();

        switch(_name) {
          case 'china':
            country.name = 'Mainland China';
            break;
          case 'hong kong':
            country.name = 'Hong Kong S.A.R.';
            break;
          case 'macao':
            country.name = 'Macau S.A.R.';
            break;
          default:
            country.name = country.name;
        }
      }
    });
  }

  return countries;
};

export default {
  async getAll() {
    return await axios
      .get(endpoint + '/list')
      .then(response => {
        return _transformCountryName(response.data.data);
      }).catch(error => {
        throw error.response.data
      });
  },
}



// WEBPACK FOOTER //
// ./src/services/master/countryService.js